import type { CalendarEventType } from '@/lib/absences';

/**
 * HW-719: per-event-type brand fallback colours, used when an event has no
 * configured absence-type colour (`absenceTypeColor` null) — e.g. a pending
 * request for a colourless type. Keeps the chip legible instead of a faint gray.
 * Single source of truth for the month grid, the schedule bar and the exports.
 */
export const EVENT_TYPE_FALLBACK_COLOR: Record<CalendarEventType, string> = {
  birthday: '#7E5F6E', // plum (celebration)
  leave_request: '#427A75', // brand teal 500 (derived from #183633)
  first_day: '#4F7079', // dusk teal (welcome)
  last_day: '#A56142', // terra (departure)
  last_probation_day: '#A8843D', // honey (warning)
};
